import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function CampaignListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            detailsHref={"/campaign-transaction/details"}
                            objectKeys={[
                                "id",
                                "campaign_player_currency.campaign.name", 
                                "campaign_player_currency.player_currency.player.id", 
                                "campaign_player_currency.player_currency.currency.iso_code",
                                "transaction.id",  
                                "transaction.operator_transaction_id",  
                                "transaction.provider_transaction_id",  
                                "transaction.round_id",  
                                "transaction.amount",  
                                "transaction.status",  
                                "transaction.type",  
                                "transaction.created_at",  
                                "transaction.updated_at",  
                            ]}
                            columnTitles={[
                                "ID",
                                "Campaign Name",
                                "Player ID",
                                "Currency",
                                "Transaction ID", 
                                "Operator Transaction ID", 
                                "Provider Transaction ID", 
                                "Round ID", 
                                "Amount",
                                "Transaction Status",
                                "Transaction Type",
                                "Transaction Created At",
                                "Transaction Updated At"
                            ]}
                            pageTitle={"Campaign Transactions"}
                            readEndpoint={"campaign-player-currency-transaction/read"}
                            relations={["campaign_player_currency", "transaction", "campaign_player_currency.campaign", "campaign_player_currency.player_currency", "campaign_player_currency.player_currency.player", "campaign_player_currency.player_currency.currency"]}
                            />
        </>
    )
}

export default CampaignListPage;